export default function PlayerVsPlayerIcon() {
  return (
    <svg width='82px' height='46px' viewBox='0 0 82 46' version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <title>player-vs-player</title>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='player-vs-player'>
          <circle id='Oval-Copy-17' fill='#000000' cx='59' cy='23' r='23'></circle>
          <circle fill='#FFCE67' cx='59' cy='23' r='20'></circle>
          <g transform='translate(52.333333, 14.666667)' stroke='#000000' strokeWidth='3'>
            <path d='M5,22.2916667 C10.5228475,22.2916667 15,17.8145142 15,12.2916667 C15,6.76881917 10.5228475,2.29166667 5,2.29166667' transform='translate(10.000000, 12.291667) rotate(90.000000) translate(-10.000000, -12.291667) '></path>
            <g transform='translate(8.125000, -0.000000)'>
              <line x1='0.416666667' y1='0' x2='0.416666667' y2='4.98700291'></line>
              <line x1='8.75' y1='0' x2='8.75' y2='4.98700291'></line>
            </g>
          </g>
          <circle id='Oval-Copy-18' fill='#000000' cx='23' cy='23' r='23'></circle>
          <g transform='translate(3.000000, 3.000000)'>
            <circle fill='#FFCE67' cx='20' cy='20' r='20'></circle>
            <g transform='translate(13.333333, 11.666667)' stroke='#000000' strokeWidth='3'>
              <path d='M5,22.2916667 C10.5228475,22.2916667 15,17.8145142 15,12.2916667 C15,6.76881917 10.5228475,2.29166667 5,2.29166667' transform='translate(10.000000, 12.291667) rotate(90.000000) translate(-10.000000, -12.291667) '></path>
              <g transform='translate(8.125000, 0.000000)'>
                <line x1='0.416666667' y1='0' x2='0.416666667' y2='4.98700291'></line>
                <line x1='8.75' y1='0' x2='8.75' y2='4.98700291'></line>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
